module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotTemplateSlotGroupDetails) ? _c('b-modal', {
    ref: "missionSlotTemplateSlotCreateModal",
    attrs: {
      "id": "missionSlotTemplateSlotCreateModal",
      "size": "lg",
      "title": _vm.slotCreateTitle,
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionSlotTemplateSlotCreateData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.addMissionSlotTemplateSlot($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.title'),
      "state": _vm.missionSlotTemplateSlotCreateTitleState,
      "feedback": _vm.missionSlotTemplateSlotCreateTitleFeedback,
      "description": _vm.$t('mission.slot.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateSlotCreateData.title),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotCreateData.title = $$v
      },
      expression: "missionSlotTemplateSlotCreateData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.description.optional'),
      "state": "success",
      "description": _vm.$t('mission.slot.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": ""
    },
    model: {
      value: (_vm.missionSlotTemplateSlotCreateData.description),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotCreateData.description = $$v
      },
      expression: "missionSlotTemplateSlotCreateData.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.difficulty'),
      "state": "success",
      "description": _vm.$t('mission.slot.difficulty.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionSlotTemplateSlotCreateDifficultyOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateSlotCreateData.difficulty),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotCreateData.difficulty = $$v
      },
      expression: "missionSlotTemplateSlotCreateData.difficulty"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.reserve.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.reserve.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotTemplateSlotCreateData.reserve),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotCreateData.reserve = $$v
      },
      expression: "missionSlotTemplateSlotCreateData.reserve"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.blocked.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.blocked.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotTemplateSlotCreateData.blocked),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotCreateData.blocked = $$v
      },
      expression: "missionSlotTemplateSlotCreateData.blocked"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.detailedDescription.optional'),
      "state": "success",
      "description": _vm.$t('mission.slot.detailedDescription.description')
    }
  }, [_c('quill-editor', {
    ref: "missionSlotTemplateSlotCreateDetailedDescriptionEditor",
    attrs: {
      "options": _vm.missionSlotTemplateSlotCreateDetailedDescriptionEditorOptions
    },
    model: {
      value: (_vm.missionSlotTemplateSlotCreateData.detailedDescription),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotCreateData.detailedDescription = $$v
      },
      expression: "missionSlotTemplateSlotCreateData.detailedDescription"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.insertAfter'),
      "state": "success",
      "description": _vm.$t('mission.slot.insertAfter.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionSlotTemplateSlotCreateInsertAfterOptions
    },
    model: {
      value: (_vm.missionSlotTemplateSlotCreateData.insertAfter),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotCreateData.insertAfter = $$v
      },
      expression: "missionSlotTemplateSlotCreateData.insertAfter"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot template slot create actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.addMissionSlotTemplateSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotTemplateSlotCreateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ecb580c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotCreateModal.vue
// module id = 546
// module chunks = 0